import { render } from "./VendorIndex.vue?vue&type=template&id=08c49d3e"
import script from "./VendorIndex.vue?vue&type=script&lang=js"
export * from "./VendorIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__